module.exports = __webpack_public_path__ + "img/14.c651d9d1.jpg";